import _ from 'underscore';

export default class BaseComponent
{
    constructor() {
        this.events = [];
        this.resizeTimer = 100;
        this.scrollTimer = 50;
        this.setupWindowEvents();
    }

    addEvent(selector, eventName, callback) {
        this.events.push(this.element.find(selector).on(eventName, e => callback(e)));
    }

    setupWindowEvents() {
        if (typeof this.onWindowResize !== 'undefined') {
            $(window).on('resize', _.debounce(() => {
                this.onWindowResize();
            }, this.resizeTimer));
        }

        if (typeof this.onWindowScroll !== 'undefined') {
            $(window).on('scroll', _.debounce(() => {
                this.onWindowScroll();
            }, this.scrollTimer));
        }
    }

    childElements(selector)
    {
        if (this.element) {
            return this.element.find(selector);
        }

        return null;
    }

    domElement() {
        return this.element.get(0);
    }

    /**
     * Scroll to an element on the page.
     *
     * @param {HTMLElement} element  The element to scroll.
     * @param {integer}     offset   Offset top to scroll to.
     * @param {integer}     duration How long the scroll takes.
     */
    scrollTo(element, offset = 0, duration = 100) {
        $('html,body').animate({
            scrollTop: element.offset().top - offset
        }, duration);
    }
}


// WEBPACK FOOTER //
// ./src/js/base/BaseComponent.js